import styled             from 'styled-components';

import { ButtonVariants } from 'src/components/common/button';
import { RatingVariants } from 'src/components/common/rating';

import { cssFlexColumn,
         Typo,
         themeTypos,
         typoAsCSS,
         themeColors    } from 'src/providers/theme/shared';



type RateInlineLookAndFeel = {
  paddings: number[];
  borderColor: string;
  backgroundColor: string;

  noteTypo: Typo;
  noteColor: string;

  sendButtonTopPadding: number;

  ratingVariant: RatingVariants;
  sendButtonVariant: ButtonVariants;
}

const rateinline_light: RateInlineLookAndFeel = {
  paddings: [12, 16, 16, 16],
  borderColor: themeColors.BorderPastelBluePrimary2,
  backgroundColor: themeColors.PrimaryWhite,

  noteTypo: themeTypos.GRTSKREG_W400_S12_LH16,
  noteColor: themeColors.TextNeutralText100,

  sendButtonTopPadding: 16,

  ratingVariant: 'h46s24',
  sendButtonVariant: 'text',
}

export type RateInlineVariants = 'light';

export const rateinline_variants: Map<RateInlineVariants, RateInlineLookAndFeel> = 
  new Map<RateInlineVariants, RateInlineLookAndFeel>([
    ['light', rateinline_light],
  ]);

export const Container = styled.div<{
  lookAndFeel: RateInlineLookAndFeel
}>`
  ${cssFlexColumn};
  align-items: center;

  padding-top: ${(args) => args.lookAndFeel.paddings[0]}px;
  padding-right: ${(args) => args.lookAndFeel.paddings[1]}px;
  padding-bottom: ${(args) => args.lookAndFeel.paddings[2]}px;
  padding-left: ${(args) => args.lookAndFeel.paddings[3]}px;

  border: 1px solid ${(args) => args.lookAndFeel.borderColor};
  border-radius: 12px;
  background-color: ${(args) => args.lookAndFeel.backgroundColor};
`

export const Note = styled.div<{
  lookAndFeel: RateInlineLookAndFeel
}>`
  ${(args) => typoAsCSS(args.lookAndFeel.noteTypo)};
  color: ${(args) => args.lookAndFeel.noteColor};
  text-align: center;
`
